import React from "react";
import { MultiSelect } from "primereact/multiselect";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./MultiSelect.css"; // Import the custom CSS file

const SkillsMultiSelect = ({
  items,
  label,
  selectedItems,
  astroData,
  setastroData,
}) => {
  const handleChange = (selectedItems) => {
    setastroData((prevData) => ({
      ...prevData,
      [label.toLowerCase()]: selectedItems,
    }));
  };

  return (
    <div className="w-full">
      <label className="text-md font-normal mb-1 flex flex-row mr-auto">
        {label}
        {/* <p className="text-red-500 ml-1 text-md">*</p> */}
      </label>

      <MultiSelect
        closeIcon={<></>}
        value={selectedItems}
        options={items}
        showSelectAll={false}
        onChange={(e) => handleChange(e.value)}
        display="chip"
        placeholder={`Select ${label}`}
        className={`py-${selectedItems.length > 0 ? 1 : 2
          } w-full border rounded-md text-sm px-2 border-1 border-zinc-300 bg-white`}
        itemClassName={`bg-yellow-500 text-white`} // Not working
        panelClassName={`bg-[#F5F5F7]`} // Not working
      />
    </div>
  );
};

export default SkillsMultiSelect;
